import dictionary from './dictionary.json';
const config = {
    resource: 'next-postal-code',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map